import { type Menu } from '@/models/restaurant/Menu';
import { type ListMenusAndItemsResponse } from '../../models/restaurant/ListMenusAndItemsResponse';
import type { MenuSection } from '../../models/restaurant/MenuSection';
import { createApiResource } from '../api';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

export const menuApi = {...createApiResource<Menu, string>('restaurant/menus'),    
    listMenusAndItems: async (locationId: string): Promise<ListMenusAndItemsResponse> => {
        const response = await fetch(`${BASE_URL}/restaurant/menus?includeAllItems=true`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`,
                'x-location-id': locationId
            }
        });
        const data = await response.json();
        if (!response.ok) throw new HttpError(response.status, data);
        return await data;
    },    
    updateSection: async (locationId: string, menuId: string, section: MenuSection): Promise<void> => {
        const response = await fetch(`${BASE_URL}/restaurant/menus/${menuId}/sections/${section.id}`, {
            method: 'PUT',
            body: JSON.stringify(section),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getJwt()}`,
                'x-location-id': locationId
            },
        });

        const contentType = response.headers.get('content-type') ?? '';
        const data = contentType.includes('json') ? await response.json().catch(() => null) : await response.text().catch(() => '');

        if (!response.ok) throw new HttpError(response.status, data);       
    },
    toggleSectionHidden: async (id: string): Promise<void> => {
        const response = await fetch(`${BASE_URL}/restaurant/menus/sections/${id}/hidden`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });

        const contentType = response.headers.get('content-type') ?? '';
        const data = contentType.includes('json') ? await response.json().catch(() => null) : await response.text().catch(() => '');

        if (!response.ok) throw new HttpError(response.status, data);       
    }};